import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../app.component';
import {NavigationEnd, ActivatedRoute} from '@angular/router';
import {Batiment} from '../Models/Batiment';
import {filter} from 'rxjs/operators';
import {cloneDeep} from "lodash";
import _ from 'lodash';
import {environment} from "../../environments/environment";
import {ROUTES_PATHS} from "../const/routes";
import {menuItemsHeader} from "../const/menu-items-header";

@Component({
	selector: 'app-sidebar-menu',
	templateUrl: './sidebar-menu.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./sidebar-menu.component.less']
})
export class SidebarMenuComponent implements OnInit {
	globalTxt: any = null;
	textes: any = null;
	optsTypePiece: any = null;
	fctGetPictoMenu: any;
	arrPieces: any = [];
	estimation: any;
	picByType: any;
	_filter = filter;
	//queryParams: any;
	batiment: Batiment = JSON.parse(localStorage.getItem("BATIMENT")!);
	PicTypeId: any;
	PicId: any;
	dmgPicPiece: any = {};
	arrDmgByPiece: any = [];
	menuItems: any[] = [];
	imageUrl = "/assets/images/logo_KT.svg";
	boShowed = false;
	widthLogo = "130";

	constructor(
		public app: AppComponent,
		private activatedRoute: ActivatedRoute
	) {
	}

	ngOnInit(): void {
		//this.queryParams = this.activatedRoute.snapshot.queryParams;

		this.arrDmgByPiece = (JSON.parse(localStorage.getItem("arrDmgByPiece")!)) ? JSON.parse(localStorage.getItem("arrDmgByPiece")!) : [];
		console.log("this.arrDmgByPiece", this.arrDmgByPiece);

		this.PicTypeId = this.activatedRoute.snapshot.params['typeId'];
		this.PicId = this.activatedRoute.snapshot.params['picId'];
		console.log("this.PicTypeId", this.PicTypeId);
		console.log("this.PicId", this.PicId);

		this.app.sharedToolsService.getJSON("selectOpts").subscribe(opts => {
			this.optsTypePiece = cloneDeep(opts.optsTypePiece);

			// ==> Get json for functions : Percent for pieces switch type de bien (Appartement Haussemanien : id = 1, Appartement : id = 2, Maison : id = 3) et number of pieces (T1, T2...) OU regarder "selectOpts.json" pour voir correspondances
			this.app.sharedToolsService.getJSON("forFunctions").subscribe(data => {
				this.fctGetPictoMenu = cloneDeep(data.fctGetPictoMenu);
				console.log("this.fctGetPictoMenu", this.fctGetPictoMenu);

				// ==> On récupere l'estimation et les pieces du localStorage mais dans le futur la recuperer par un service getEstimation() getPieces()
				//this.arrPieces = JSON.parse(localStorage.getItem("arrPieces")!);
				//this.estimation = JSON.parse(localStorage.getItem("estimation")!);

				// ==> On récupere les pieces
				this.app.apiToolsService.getSinistreByID(parseInt(this.batiment.simulationId!), true).subscribe(res => {
					console.log("res getSinistreByID ==> ", res);

					this.arrPieces = cloneDeep(res);

					this.arrPieces.forEach((pic: any) => {
						let piece: any;
						piece = this.fctGetPictoMenu.filter((obj: any) => {
							return obj.picId == pic.type;
						})[0];

						if (piece) pic.icon = piece.icon; //pic.label = piece.label;

						pic.showCount = _.filter(this.arrPieces, function (item) {
							return item.type == pic.type;
						}).length > 1;

						this.dmgPicPiece = {
							PIC_ID: pic.id
						}

						if (this.arrDmgByPiece.length > 0) {
							let picAlreadyInList: any = this.arrDmgByPiece.filter((dmg: any) => {
								return dmg.PIC_ID == pic.id;
							})[0];
							//console.log("picAlreadyInList ==> ", picAlreadyInList);

							if (!picAlreadyInList) this.arrDmgByPiece.push(this.dmgPicPiece);
							return;
						}

						this.arrDmgByPiece.push(this.dmgPicPiece);

					});

					console.log("this.arrPieces alt ==> ", this.arrPieces);

					// ==> On verifie s'il y a des PIC id qui ont été éffacés lors d'une édition et on les enleve aussi du localstorage.
					let arrayNotInArrayPieces = this.arrDmgByPiece.filter((o1: any) => !this.arrPieces.some((o2: any) => o1.PIC_ID === o2.id));
					console.log("arrayNotInArrayPieces ==> ", arrayNotInArrayPieces);

					arrayNotInArrayPieces.forEach((pieceNotExists: any) => {

						let index = this.arrDmgByPiece.findIndex((element: any) => {
							return element.PIC_ID == pieceNotExists.PIC_ID
						})

						this.arrDmgByPiece.splice(index, 1);
					})

					localStorage.setItem("arrDmgByPiece", JSON.stringify(this.arrDmgByPiece));

					//console.log("this.arrDmgByPiece", this.arrDmgByPiece);
					console.log("this.PicTypeId", this.PicTypeId);
					console.log("this.PicId", this.PicId);

					setTimeout(() => {
						let _id = document.getElementById('piece_' + this.PicId.toString());
						console.log("_id ==> ", _id);
						if (_id != null) _id.classList.add("active");
					}, 100);
				});


			});
		});

		// Load the nameJson and initialize the component
		this.app.dataInitService.getNameJsonReady((nameJson) => {
			this.getInfosInit(nameJson);
		});
	}

	getInfosInit(_nameJson: any) {
		// Get Settings
		this.app.sharedToolsService.getParamSettings('logo_header_sidebar').subscribe(url => {
			this.imageUrl = url;
		});

		this.app.sharedToolsService.getParamSettings('width_logo').subscribe((width_logo: string) => {
			if (width_logo) this.widthLogo = width_logo;
		});

		// ==> Get Textes globaux
		this.app.dataToolsService.currentGlobalTexts.subscribe(object => {

			if (!object) {
				this.app.sharedToolsService.getGlobalTexts();
			}

			this.globalTxt = object;

			this.app.sharedToolsService.getParamSettings('bo_showed').subscribe((is_showed: boolean) => {
				this.boShowed = is_showed;

				// Get the menu items
				let _menuItemsHeader = menuItemsHeader;
				this.menuItems = _menuItemsHeader.filter((item: any) =>
					item.environment?.includes(environment.name)
					&& !(item.path === ROUTES_PATHS.MON_COMPTE && !this.boShowed)
				);
			});


			// ==> Get Textes de la page
			this.app.sharedToolsService.getJSON(_nameJson).subscribe(resp => {
				this.textes = resp.data;
				console.log('getInfosInit this.textes ==> ', this.textes, _nameJson);
			});

		});
	}

	onClickNavLink(id: string, picType: any, picId: any, event: any) {
		console.log('id ==> ', id);
		this.app.router.events.pipe(this._filter(e => e instanceof NavigationEnd)).subscribe((ev: any) => {
			console.log("ev ==> ", ev);
			setTimeout(() => {
				window.location.reload();
			}, 100);
		});

		this.app.router.navigate(['/' + ROUTES_PATHS.PIECE_PAR_PIECE + '/' + picType + '/' + picId]);
	}

	public readonly ROUTES_PATHS = ROUTES_PATHS;
}
